'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);
var functions = require('./functions.js');
var magicSdk = require('@gig/magic-sdk');

const RETURNING_USER_KEY = "returning-user";
const UserRolesUpdated = () => {
  return Component.createDecorator((options, key) => {
    if (!options.methods) {
      options.methods = {};
    }
    const functionToCall = options.methods[key];
    if (functionToCall && typeof functionToCall === "function") {
      const subscriptions = [];
      options.created = functions.hookFunction(options.created, function() {
        const handler = (event) => {
          if (!!event.addedRoles || !!event.removedRoles) {
            functionToCall.call(this, event);
          }
        };
        subscriptions.push(magicSdk.magic.events.userUpdated((updateEvent) => handler(updateEvent)).unsub);
      });
      options.beforeDestroy = functions.hookFunction(options.beforeDestroy, function() {
        subscriptions.forEach((unsub) => {
          unsub();
        });
      });
    }
  });
};
function isReturningUser() {
  try {
    return !!window.localStorage.getItem(RETURNING_USER_KEY);
  } catch (e) {
    return true;
  }
}

exports.UserRolesUpdated = UserRolesUpdated;
exports.isReturningUser = isReturningUser;
